import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import AdminModeBar from './components/AdminModeBar';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Careers from './pages/Careers';
import Contact from './pages/Contact';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import AdminLogin from './pages/admin/AdminLogin';
import AdminCompany from './pages/admin/AdminCompany';
import AdminJobs from './pages/admin/AdminJobs';
import AdminInquiries from './pages/admin/AdminInquiries';
import AdminApplications from './pages/admin/AdminApplications';
import AdminContracts from './pages/admin/AdminContracts';
import AdminEvents from './pages/admin/AdminEvents';
import AdminFaqs from './pages/admin/AdminFaqs';
import AdminNotices from './pages/admin/AdminNotices';
import AdminFreelancers from './pages/admin/AdminFreelancers';
import AdminContractContents from './pages/admin/AdminContractContents';
import MyLogin from './pages/my/MyLogin';
import MyContracts from './pages/my/MyContracts';
import MyContractDetail from './pages/my/MyContractDetail';
import MyManual from './pages/my/MyManual';
import AdminManual from './pages/admin/AdminManual';
import './styles/global.css';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

// 일반 방문자용 페이지: 공통 Header/Footer 포함
function PublicLayout() {
  return (
    <>
      <AdminModeBar />
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
      </Routes>
      <Footer />
    </>
  );
}

// 관리자 페이지: 별도 레이아웃 (Header/Footer 없음, 로그인 보호는 각 페이지 내부에서 처리)
function AdminRoutes() {
  return (
    <Routes>
      <Route path="/admin" element={<Navigate to="/admin/company" replace />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin/company" element={<AdminCompany />} />
      <Route path="/admin/events" element={<AdminEvents />} />
      <Route path="/admin/jobs" element={<AdminJobs />} />
      <Route path="/admin/inquiries" element={<AdminInquiries />} />
      <Route path="/admin/applications" element={<AdminApplications />} />
      <Route path="/admin/freelancers" element={<AdminFreelancers />} />
      <Route path="/admin/contract-contents" element={<AdminContractContents />} />
      <Route path="/admin/contracts" element={<AdminContracts />} />
      <Route path="/admin/notices" element={<AdminNotices />} />
      <Route path="/admin/faqs" element={<AdminFaqs />} />
      <Route path="/admin/manual" element={<AdminManual />} />
    </Routes>
  );
}

// 일반 사용자(아르바이트생) 전용 페이지: 별도 레이아웃, 근로계약서 확인/서명만 가능
function MyRoutes() {
  return (
    <Routes>
      <Route path="/my" element={<Navigate to="/my/contracts" replace />} />
      <Route path="/my/login" element={<MyLogin />} />
      <Route path="/my/contracts" element={<MyContracts />} />
      <Route path="/my/contracts/:id" element={<MyContractDetail />} />
      <Route path="/my/manual" element={<MyManual />} />
    </Routes>
  );
}

function AppRoutes() {
  const location = useLocation();
  if (location.pathname.startsWith('/admin')) return <AdminRoutes />;
  if (location.pathname.startsWith('/my')) return <MyRoutes />;
  return <PublicLayout />;
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <AppRoutes />
    </BrowserRouter>
  );
}
